<template>
    <div class="confirmation-box">
      <el-card class="card-container">
        <template #header>
          <div class="card-header">
            <span>Pre-Order Confirmation</span>
          </div>
        </template>
        <div v-if="preorder">
          <div>
            <el-card v-if="preorder.timeline">
              <p>Order Status</p>
              <el-timeline>
                <el-timeline-item
                  v-for="(activity, index) in preorder.timeline"
                  :key="index"
                  :color="getColorBasedOnEvent(activity.event)"
                  :timestamp="activity.timestamp.toDate().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric' })"
                >
                  {{ activity.event }}
                </el-timeline-item>
              </el-timeline>
            </el-card>
            <div class="card p-2 background-container">
              <div class="invoice">
                <span class="font-weight-bold d-block mt-4 mb-2"
                  >Hello, {{ preorder.firstName }} {{ preorder.lastName }}.</span
                >
                <div v-if="preorder.isOrganizationOrder"><el-tag class="mb-3 mt-1">Organization Order</el-tag></div>
                <span>You preorder has been received! A confirmation email will be sent to you once the item has been successfully shipped.</span>
                <div
                  class="payment bpreorder-top mt-3 bpreorder-bottom table-responsive mb-0"
                >
                  <table class="table table-bpreorderless">
                    <tbody>
                      <tr>
                        <td>
                          <div class="py-2">
                            <span class="d-block muted-text">Order Date</span>
                            <span>{{ formatDate(preorder.orderDate )}}</span>
                          </div>
                        </td>
                        <td>
                          <div class="py-2">
                            <span class="d-block muted-text">Order No</span>
                            <span>{{ preorder.id }}</span>
                          </div>
                        </td>
                        <td>
                          <div class="py-2 text-right">
                            <span class="d-block muted-text">Payment</span>
                            <span
                              ><img
                                src="../../assets/images/stripe-logo.png"
                                width="50"
                            /></span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table class="table table-bpreorderless">
                    <tbody>
                      <tr>
                        <td>
                          <div class="py-2">
                            <span class="d-block muted-text"
                              >Shipping Address</span
                            >
                            <span>{{  getAddress(preorder) }}</span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="product bpreorder-bottom table-responsive">
                  <table class="table table-bpreorderless">
                    <tbody>
                      <tr>
                        <td width="20%">
                          <img
                            class="rounded"
                            src="../../assets/images/knee_sleeve.png"
                            width="90"
                          />
                        </td>
                        <td width="60%">
                          <span class="font-weight-bold">Knee Sleeve</span>
                          <div class="product-qty">
                            <span class="d-block"
                              >Quantity: {{ preorder.quantity }}</span
                            >
                          </div>
                        </td>
                        <td width="20%">
                          <div class="text-right">
                            <span class="font-weight-bold">
                              {{ preorder.total }}</span
                            >
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="row d-flex justify-content-end">
                  <div class="col-md-5 pr-0">
                    <table class="table table-bpreorderless">
                      <tbody class="totals">
                        <tr>
                          <td>
                            <div class="text-left">
                              <span class="muted-text">Subtotal</span>
                            </div>
                          </td>
                          <td>
                            <div class="text-right">
                              <span> {{  preorder.subtotal }}</span>
                            </div>
                          </td>
                        </tr>
                        <!-- <tr>
                                     <td>
                                        <div class="text-left">
                                           <span class="muted-text">Shipping Fee</span>
                                        </div>
                                     </td>
                                     <td>
                                        <div class="text-right">
                                           <span> 0</span>
                                        </div>
                                     </td>
                                  </tr> -->
                        <tr>
                          <td>
                            <div class="text-left">
                              <span class="muted-text">PST (7%)</span>
                            </div>
                          </td>
                          <td>
                            <div class="text-right">
                              <span> {{ preorder.pst }}</span>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div class="text-left">
                              <span class="muted-text">GST (5%)</span>
                            </div>
                          </td>
                          <td>
                            <div class="text-right">
                              <span> {{ preorder.gst }}</span>
                            </div>
                          </td>
                        </tr>
                        <!-- <tr>
                                     <td>
                                        <div class="text-left">
                                           <span class="muted-text">Discount</span>
                                        </div>
                                     </td>
                                     <td>
                                        <div class="text-right">
                                           <span class="text-success">168.50</span>
                                        </div>
                                     </td>
                                  </tr> -->
                        <tr class="bpreorder-top bpreorder-bottom">
                          <td>
                            <div class="text-left">
                              <span class="font-weight-bold">Total</span>
                            </div>
                          </td>
                          <td>
                            <div class="text-right">
                              <span class="font-weight-bold">
                                {{ preorder.total }}</span
                              >
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <p class="font-weight-bold mb-0">Thanks for shopping with us!</p>
                <span>Texavie Team</span>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <el-skeleton :rows="5" animated />
        </div>
      </el-card>
    </div>
  </template>

<script>
import { onMounted, ref } from 'vue'
import getKneeSleevePreorders from '../../composables/getKneeSleevePreorders'
import { xray } from '../../config/pluginInit'
export default {
    mounted () {
    xray.index()
  },
  name: 'KneeSleevePrepreorderDetails',
  props: ['id'],
  setup (props, context) {
    const { getPreOrderById } = getKneeSleevePreorders()
    const preorder = ref(null)

    onMounted(async () => {
      preorder.value = await getPreOrderById(props.id)
    })

    const formatDate = (timestamp) => {
      const date = timestamp.toDate()
      const options = { month: 'long', day: 'numeric', year: 'numeric' }
      return date.toLocaleDateString('en-US', options)
    }

    const getAddress = (preorder) => {
      const addressParts = [
        preorder.streetAddress,
        preorder.address2,
        preorder.city,
        preorder.state,
        preorder.postalCode,
        preorder.country
      ].filter(part => part)

      return addressParts.join(', ')
    }

    const getColorBasedOnEvent = (event) => {
      switch (event) {
        case 'Payment received':
          return '#E6A23C'
        case 'Preparing Order':
          return '#F56C6C'
        case 'Ready for Dispatch':
          return '#909399'
        case 'Order Shipped':
          return '#409eff'
        case 'Order Delivered':
          return '#67C23A'
        default:
          return '#909399'
      }
    }

    return {
      preorder,
      formatDate,
      getAddress,
      getColorBasedOnEvent
    }
  }
}
</script>

  <style scoped>
  .card-container {
    margin: 0 20px 20px 20px;
  }

  .card-header {
    background: transparent;
    border-bottom: none;
  }

  .card-header span {
    font-size: 16px;
    font-weight: 500;
    color: var(--text-color) !important;
  }

  </style>

  <style>
    .el-timeline {
    margin-bottom: 0 !important;
  }
  </style>
